import { jsx } from "react/jsx-runtime";
import { AccordionItemIcon } from "./index.js";
import { removeQueryParams, fetchSvg } from "../../../../shared/index.js";
import { extractColorsByType } from "./lib.js";
const createAccordionItemIcons = ({
  icon,
  originalSvg,
  activeIconColor,
  defaultIconColor,
  hoverIconColor
}) => {
  if (!icon || !originalSvg) {
    return {
      activeIconColor: null,
      hoverIconColor: null,
      defaultIconColor: null
    };
  }
  return {
    activeIconColor: /* @__PURE__ */ jsx(
      AccordionItemIcon,
      {
        color: activeIconColor,
        icon,
        originalSvg
      }
    ),
    defaultIconColor: /* @__PURE__ */ jsx(
      AccordionItemIcon,
      {
        color: defaultIconColor,
        icon,
        originalSvg
      }
    ),
    hoverIconColor: /* @__PURE__ */ jsx(
      AccordionItemIcon,
      {
        color: hoverIconColor,
        icon,
        originalSvg
      }
    )
  };
};
const createSvgIconsMap = async ({
  config,
  content
}) => {
  const defaultIconColor = extractColorsByType("default_colors", config);
  const activeIconColor = extractColorsByType("active_colors", config);
  const hoverIconColor = extractColorsByType("hover_colors", config);
  return content.reduce(
    async (accPromise, accordionItem) => {
      var _a;
      const acc = await accPromise;
      const iconData = (_a = accordionItem.accordion_icon) == null ? void 0 : _a[0];
      if (!iconData) {
        return acc;
      }
      const icon = iconData.icon_image || iconData;
      if (!icon || !icon.url) {
        return acc;
      }
      const iconUrlSvg = removeQueryParams(icon.url, ["auto", "format"]);
      let originalSvg;
      if (icon.url.toLowerCase().includes(".svg")) {
        try {
          originalSvg = await fetchSvg(iconUrlSvg);
        } catch (error) {
          console.warn(
            `Failed to fetch SVG for accordion icon: ${icon.url}`,
            error
          );
          originalSvg = void 0;
        }
      }
      if (accordionItem._metadata) {
        acc[accordionItem._metadata.uid] = {
          defaultIconColor,
          activeIconColor,
          hoverIconColor,
          icon,
          originalSvg
        };
      }
      return acc;
    },
    Promise.resolve({})
  );
};
export {
  createAccordionItemIcons,
  createSvgIconsMap
};
